import { ScrollArea } from '@/components/ui/scroll-area';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Package } from 'lucide-react';
import { Produtos } from '@/types/DetailNF'
import { currencyFormat, numberFormat } from '@/utils/stringFormatter';

interface PropsProducts {
  products: Produtos[]
}

export function ProductsTable({products}: PropsProducts ) {
  const totalAmount = products.reduce((sum, product) => sum + Number(product.VL_TOTAL), 0);

  return (
    <Card className='min-h-[380px]'>
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center text-lg">
          <Package className="w-5 h-5 mr-2" />
          Produtos
        </CardTitle>
      </CardHeader>
      <CardContent>
        <ScrollArea className=" rounded-md border">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Item</TableHead>
                <TableHead className="w-[40%]">Produto</TableHead>
                <TableHead className="text-right">Quantidade</TableHead>
                <TableHead className="text-right">U.M.</TableHead>
                <TableHead className="text-right">Vl. Unitário</TableHead>
                <TableHead className="text-right">Vl. Total</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {products.map((product) => (
                <TableRow key={product.SK_NUMERO_ITEM}>
                  <TableCell className="text-center">{product.SK_NUMERO_ITEM}</TableCell>
                  <TableCell>{product.DS_PRODUTO}</TableCell>
                  <TableCell className="text-right">{numberFormat(product.QTD_PRODUTO)}</TableCell>
                  <TableCell>{product.DD_UNIDADE_MEDIDA}</TableCell>
                  <TableCell className="text-right">{numberFormat(product.VL_UNITARIO)}</TableCell> 
                  <TableCell className="text-right">{numberFormat(product.VL_TOTAL)}</TableCell> 
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </ScrollArea>
        <div className="mt-4 flex justify-end">
          <div className="text-lg font-semibold">
            Total: {currencyFormat(totalAmount)} 
          </div>
        </div>
      </CardContent>
    </Card>
  );
}